'use strict';

var React = require('react');

var SvgMarketsIcon = function SvgMarketsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 10a7 7 0 0 1 12.584-4.222 2.013 2.013 0 0 0-1.604.427 5.528 5.528 0 0 0-1.105-.895 1.85 1.85 0 0 1-1.477.735.352.352 0 0 0-.353.353v.04c0 .587-.271 1.14-.736 1.499l-.462.356a.256.256 0 0 0 .153.457h1.877a3.482 3.482 0 0 0-.592 1.5h-1.285a1.755 1.755 0 0 1-1.07-3.144l.463-.356a.393.393 0 0 0 .152-.312v-.04c0-.885.62-1.624 1.449-1.808a5.497 5.497 0 0 0-5.73 2.613l1.999 1.999c.472.472.737 1.113.737 1.78v.518a.5.5 0 0 0 .5.5 2 2 0 0 1 2 2v1.478c.256-.024.508-.064.753-.121.028.546.277 1.035.658 1.379a7 7 0 0 1-8.911-6.736Zm1.5 0c0-.443.052-.875.152-1.288l1.55 1.55c.19.191.298.45.298.72v.518a2 2 0 0 0 2 2 .5.5 0 0 1 .5.5v1.41a5.502 5.502 0 0 1-4.5-5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 7a.75.75 0 0 1 .75.75v.75h.75a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 0 0 1.5h.5a2.25 2.25 0 0 1 .25 4.486v.264a.75.75 0 0 1-1.5 0v-.25h-.75a.75.75 0 0 1 0-1.5h2a.75.75 0 0 0 0-1.5h-.5a2.25 2.25 0 0 1-.25-4.486v-.764a.75.75 0 0 1 .75-.75Z"
  }));
};
SvgMarketsIcon.displayName = "MarketsIcon";

exports.SvgMarketsIcon = SvgMarketsIcon;
